// extracted by mini-css-extract-plugin
module.exports = {"backInStockButton":"_1pcjo","fullWidth":"OzftX"};